/**
 * @desc 沃尔玛平台订单自动履行发货
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.test.outPlanUpdateWaybillStatus.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/outPlanUpdateWaybillStatus`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
